import { render, staticRenderFns } from "./UpgradeComms.vue?vue&type=template&id=bbf5ee62&"
import script from "./UpgradeComms.vue?vue&type=script&lang=js&"
export * from "./UpgradeComms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports